'use strict';
import './jquery-accessibleMegaMenu';
import JSON5 from 'json5';
export default class HeaderUtil {

    static initMegamenu() {
    	const options = {
    		"mainnav": {
    			/* prefix for generated unique id attributes, which are required
                   to indicate aria-owns, aria-controls and aria-labelledby */
                uuidPrefix: "mainnav-megamenu",

                /* css class used to define the megamenu styling */
                menuClass: "c-header__mainnav-menu",

                /* css class for a top-level navigation item in the megamenu */
                topNavItemClass: "c-header__mainnav-item",

                /* css class for a megamenu panel */
                panelClass: "c-header__mainnav-subnav",

                /* css class for a group of items within a megamenu panel */
                panelGroupClass: "c-header__mainnav-subnavpanel",

                /* css class for the hover state */
                hoverClass: "is-hover",

                /* css class for the focus state */
                focusClass: "is-focus",

                /* css class for the open state */
                openClass: "is-open",

                // hover intent
                openDelay: 250
    		}
    	};

        $('[data-megamenu]').each(function() {
        	let $this = $(this);
            let opt = options[$this.attr('data-megamenu')];
            if(opt){
                $this.accessibleMegaMenu(opt);
            }
        });

        console.info('HeaderUtil: initMegamenu');
    }

    static initCloseOffCanvas(){
        $('.js-closeoffcanvas').off('click').click(function(){
            let $wrapper = $('.js-content-wrapper');
            if($wrapper.hasClass('is-menu-active')){
                $('.js-mobilemenutoggle').trigger('click');
            } else if ($wrapper.hasClass('is-search-active')){
                $('.js-mobilesearchtoggle').trigger('click');
            }
        });
    }

    static initClearSearch(){
        // data-clearsearch="[target]"
        $('[data-clearsearch]').off('click').click(function(){
            $($(this).data('clearsearch')).val('');
        });
    }

    static initSearchButtonClick(){
    	$('.js-mainsearchbtn').click(function(){
			const val = $(this).siblings('.js-inputsearch').val();
			if(val != ''){
				document.location.href = '/search?term=' + val;
			}
    	});
    }
}



// WEBPACK FOOTER //
// ./src/_js/partials/HeaderUtil.js